import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import "./NavContent.scss";
import { Nav } from "react-bootstrap";
import { icons, NAVBAR_MENU_ITEMS, scrollToSection } from "@/utils/constants";
import { MenuMobile } from "../MenuMobile/MenuMobile";
import { PopDropdown } from "../PopDropdown/PopDropdown";
import { useNavigate, useLocation } from "react-router-dom";
import { URLS } from "@/utils/constants";
import { isMobile } from "react-device-detect";
import { Button } from "react-bootstrap";
export const NavContent = ({ handleClose, }) => {
    const navigate = useNavigate();
    const { pathname } = useLocation();
    const redirect = (url) => {
        handleClose();
        if (url.startsWith("/")) {
            navigate(url);
        }
        else {
            scrollToSection(url);
        }
    };
    return (_jsxs(_Fragment, { children: [_jsx(Nav, { className: "justify-content-end flex-grow-1 pe-3", children: NAVBAR_MENU_ITEMS.map((item) => item.dropdown ? (isMobile ? (_jsx(MenuMobile, { item: item, redirect: redirect }, item.id)) : (_jsx(PopDropdown, { item: item, redirect: redirect }, item.id))) : (_jsxs(Nav.Link, { onClick: () => redirect(item.url), className: "fmc-navbar-link nav-link mx-2", children: [isMobile && (_jsx("img", { src: icons.GrainCoffee, alt: "Grano de Caf\u00E9 Flormorado", width: "17", className: "d-inline-block mx-2" })), item.title] }, item.id))) }), !pathname.includes(URLS.store) && (_jsx(Button, { onClick: () => redirect(URLS.categories), className: "fmc-navbar-button", children: _jsxs(_Fragment, { children: ["Ir a la tienda", _jsx("span", { children: _jsx("img", { src: icons.Basket2, alt: "Tienda - Flormorado Caf\u00E9", width: "20", className: "d-inline-block align-top ms-1" }) })] }) }))] }));
};
